<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-background-color="rgba(0, 0, 0, 0.3)"
      >
        <el-card v-if="!showFightBoxCard">
          <div class="search-bar">
            <el-input
              v-model="searchParams.name"
              placeholder="请输入名称"
              clearable
              style="width: 220px; margin-right: 10px"
            ></el-input>

            <el-button type="primary" icon="el-icon-search" @click="getList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetSearch"
              >重置</el-button
            >
            <el-button type="success" icon="el-icon-plus" @click="handleAdd"
              >添加爬塔</el-button
            >

            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>

          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%; margin-top: 20px"
            @row-click="handleRowClick"
          >
            <el-table-column
              label="ID"
              prop="id"
              width="80"
              align="center"
              v-if="checkedColumns.includes('id')"
            />
            <el-table-column
              label="名称"
              prop="name"
              min-width="180"
              v-if="checkedColumns.includes('name')"
            />
            <el-table-column
              label="图片"
              width="120"
              align="center"
              v-if="checkedColumns.includes('image')"
            >
              <template slot-scope="scope">
                <img
                  v-if="scope.row.image"
                  :src="scope.row.image"
                  style="width: 60px; height: 60px; object-fit: cover"
                />
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column
              label="价格"
              prop="price"
              width="100"
              align="center"
              v-if="checkedColumns.includes('price')"
            />
            <el-table-column
              label="销量"
              prop="sales"
              width="100"
              align="center"
              v-if="checkedColumns.includes('sales')"
            />
            <el-table-column
              label="层级数"
              prop="tower_num"
              width="120"
              align="center"
              v-if="checkedColumns.includes('tower_num')"
            />
            <el-table-column
              label="收入"
              prop="income"
              width="100"
              align="center"
              v-if="checkedColumns.includes('income')"
            />
            <el-table-column
              label="支出"
              prop="pay"
              width="100"
              align="center"
              v-if="checkedColumns.includes('pay')"
            />
            <!-- 利润百分比列 -->
            <el-table-column
              label="利润"
              width="120"
              align="center"
              v-if="checkedColumns.includes('profit')"
            >
              <template slot-scope="scope">
                <span v-if="Number(scope.row.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      scope.row.income - scope.row.pay >= 0
                        ? '#00c48c'
                        : '#f56c6c',
                  }"
                >
                  {{
                    (
                      ((scope.row.income - scope.row.pay) / scope.row.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="排序"
              prop="sort"
              width="80"
              align="center"
              v-if="checkedColumns.includes('sort')"
            />

            <el-table-column
              label="状态"
              width="180"
              align="center"
              v-if="checkedColumns.includes('status')"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  active-text="上架"
                  inactive-text="下架"
                  :active-value="1"
                  :inactive-value="0"
                  @click.native.stop
                  @change="handleStatusChange(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column
              label="创建时间"
              prop="created_at"
              width="180"
              v-if="checkedColumns.includes('created_at')"
            />
            <el-table-column
              label="更新时间"
              prop="updated_at"
              width="180"
              v-if="checkedColumns.includes('updated_at')"
            />

            <el-table-column
              label="操作"
              width="260"
              align="center"
              fixed="right"
              v-if="checkedColumns.includes('action')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click.stop="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-s-data"
                  @click.stop="openFightBoxNum(scope.row)"
                  >层级</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>

        <el-card v-else>
          <div class="search-bar">
            <el-button
              icon="el-icon-back"
              type="primary"
              @click="closeFightBoxCard"
              >返回爬塔列表</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="handleFightBoxAdd"
              >添加层级</el-button
            >
          </div>

          <el-table
            :key="2"
            :data="numList"
            v-loading="numLoading"
            border
            stripe
            style="width: 100%; margin-top: 20px"
            size="mini"
            @row-click="showBoxNumDetail"
          >
            <el-table-column prop="id" label="ID" width="80" align="center" />
            <el-table-column prop="box" label="层级" align="center" />
            <el-table-column prop="box_id" label="爬塔ID" align="center" />
            <el-table-column prop="price" label="价格" align="center" />
            <el-table-column prop="is_top" label="是否置顶" align="center">
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.is_top == 1
                      ? { color: '#f56c6c' }
                      : { color: '#999' }
                  "
                >
                  {{ scope.row.is_top == 1 ? "顶层" : "非顶层" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
              <template slot-scope="scope">
                <img
                  :src="scope.row.image"
                  style="width: 60px; height: 60px; object-fit: cover"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="创建时间"
              align="center"
            />
            <el-table-column
              prop="updated_at"
              label="更新时间"
              align="center"
            />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click.stop="handleFightBoxEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-box"
                  style="color: #e6a23c"
                  @click.stop="openPrizeList(scope.row)"
                  >赏品</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  style="color: #f56c6c"
                  @click.stop="delClimbTowerNum(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleNumSizeChange"
            @current-change="handleNumCurrentChange"
            :current-page="numSearch.page"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="numTotal"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>

        <!-- ====================== PC 弹窗：添加/编辑爬塔 ====================== -->
        <el-dialog
          :title="dialogType == 'add' ? '添加爬塔' : '编辑爬塔'"
          :visible.sync="dialogVisible"
          width="750px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="addRules"
            ref="formRef"
            label-width="120px"
          >
            <el-form-item label="爬塔名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入爬塔名称"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="爬塔图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="openPcImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="form.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="form.image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="form.price"
                placeholder="请输入价格"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="层级数" prop="tower_num">
              <el-input
                v-model="form.tower_num"
                placeholder="请输入层级数"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                placeholder="请输入排序值"
                style="width: 320px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- ====================== PC 弹窗：添加/编辑层级 ====================== -->
        <el-dialog
          :title="fightBoxNumId ? '编辑层级' : '添加层级'"
          :visible.sync="fightBoxNumDialog"
          width="700px"
          @close="resetFightBoxNumForm"
          append-to-body
        >
          <el-form
            :model="fightBoxNumForm"
            ref="fightBoxNumRef"
            label-width="120px"
          >
            <el-form-item label="层级">
              <el-input
                v-model.number="fightBoxNumForm.box"
                placeholder="请输入层级"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="是否置顶">
              <el-select
                v-model.number="fightBoxNumForm.is_top"
                placeholder="请选择是否置顶"
                style="width: 300px"
              >
                <el-option label="非顶层" :value="0" />
                <el-option label="顶层" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="层级图片">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="openPcImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="fightBoxNumForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="fightBoxNumForm.image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="单价">
              <el-input
                v-model.number="fightBoxNumForm.price"
                placeholder="请输入单价"
                style="width: 300px"
              />
            </el-form-item>
            <div
              v-if="
                levelList.length > 0 &&
                fightBoxNumForm.probability_info.length > 0
              "
              style="margin-top: 15px"
            >
              <div style="font-weight: bold; margin-bottom: 10px">概率配置</div>
              <div
                v-for="(lvl, index) in levelList"
                :key="lvl.level_id"
                style="
                  display: flex;
                  gap: 10px;
                  margin-bottom: 8px;
                  align-items: center;
                "
              >
                <span style="width: 120px">{{ lvl.name }}</span>
                <el-input
                  v-model.number="
                    fightBoxNumForm.probability_info[index].probability
                  "
                  placeholder="概率"
                  style="width: 120px"
                />
              </div>
            </div>
          </el-form>
          <div slot="footer">
            <el-button @click="fightBoxNumDialog = false">取消</el-button>
            <el-button type="primary" @click="submitAdd">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- ====================== PC 独立图片选择弹窗 ====================== -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="imageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetImageSearch"
                >重置</el-button
              >
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="selectPcImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    selectedPcImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    selectedPcImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>
            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="imageSearch.page"
              :page-size="imageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            />
          </div>
          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmPcSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 商品选择弹窗 -->
        <el-dialog
          title="选择门票商品"
          :visible.sync="goodsDialogVisible"
          width="900px"
          append-to-body
        >
          <div v-loading="goodsLoading" style="padding: 10px">
            <div class="goods-list">
              <div
                class="goods-item"
                v-for="item in goodsList"
                :key="item.id"
                @click="selectGoodsItem(item)"
                :class="selectedGoodsId == item.id ? 'goods-selected' : ''"
              >
                <img
                  :src="item.image"
                  style="width: 100px; height: 100px; object-fit: cover"
                />
                <div style="font-size: 12px; margin-top: 5px">
                  {{ item.title }}
                </div>
                <div style="color: red; font-size: 12px">
                  {{ item.price }}元
                </div>
              </div>
            </div>
            <el-pagination
              @size-change="handleGoodsSizeChange"
              @current-change="handleGoodsCurrentChange"
              :current-page="goodsParams.page"
              :page-sizes="[10, 20, 30]"
              :total="goodsTotal"
              layout="total, sizes, prev, pager, next, jumper"
              style="text-align: center; margin-top: 20px"
            />
          </div>
          <div slot="footer">
            <el-button @click="goodsDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmSelectGoods"
              >确认选择</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 详情弹窗 -->
        <el-dialog
          :title="detailRow ? detailRow.name + ' 的详情' : '详情'"
          :visible.sync="detailDialogVisible"
          width="850px"
          append-to-body
        >
          <div v-loading="detailLoading" style="padding: 10px">
            <el-descriptions border :column="2" size="small" v-if="detailRow">
              <el-descriptions-item label="图片">
                <img
                  :src="detailRow.image"
                  style="
                    width: 80px;
                    height: 80px;
                    object-fit: cover;
                    border-radius: 4px;
                  "
                />
              </el-descriptions-item>
              <el-descriptions-item label="ID">{{
                detailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="名称">{{
                detailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格">{{
                detailRow.price
              }}</el-descriptions-item>
              <el-descriptions-item label="层级数">{{
                detailRow.tower_num
              }}</el-descriptions-item>
              <el-descriptions-item label="销量">{{
                detailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="收入">{{
                detailRow.income
              }}</el-descriptions-item>
              <el-descriptions-item label="支出">{{
                detailRow.pay
              }}</el-descriptions-item>
              <el-descriptions-item label="利润">
                <span v-if="Number(detailRow.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      detailRow.income - detailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((detailRow.income - detailRow.pay) / detailRow.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="排序">{{
                detailRow.sort
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    detailRow.status == 1
                      ? { color: '#00C48C' }
                      : { color: '#F56C6C' }
                  "
                >
                  {{ detailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                detailRow.created_at
              }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{
                detailRow.updated_at
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </el-dialog>

        <!-- PC 层级详情弹窗 -->
        <el-dialog
          title="层级详情"
          :visible.sync="boxNumDetailVisible"
          width="700px"
          append-to-body
        >
          <div v-if="boxNumDetail" style="font-size: 14px; line-height: 28px">
            <p><b>层级ID：</b> {{ boxNumDetail.id }}</p>
            <p><b>层级：</b> {{ boxNumDetail.box }}</p>
            <p><b>爬塔ID：</b> {{ boxNumDetail.box_id }}</p>
            <p><b>价格：</b> {{ boxNumDetail.price }}</p>
            <p>
              <b>是否置顶：</b>
              {{ boxNumDetail.is_top == 1 ? "顶层" : "非顶层" }}
            </p>
            <p><b>创建时间：</b> {{ boxNumDetail.created_at }}</p>
            <p><b>更新时间：</b> {{ boxNumDetail.updated_at }}</p>
            <div style="margin-top: 20px">
              <div style="font-weight: bold; margin-bottom: 10px">
                概率配置：
              </div>
              <el-table
                :data="boxNumDetail.probability"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  label="等级ID"
                  prop="level_id"
                  align="center"
                />
                <el-table-column
                  label="概率"
                  prop="probability"
                  align="center"
                />
              </el-table>
            </div>
          </div>
        </el-dialog>

        <!-- PC 赏品弹窗 -->
        <el-dialog
          title="赏品列表"
          :visible.sync="prizeDialogVisible"
          width="1200px"
          append-to-body
        >
          <div style="margin-bottom: 15px">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openAddPrizeDialog"
              >添加赏品</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-check"
              @click="submitAddPrize"
              >确认添加</el-button
            >
          </div>
          <div style="margin-bottom: 20px">
            <p style="font-weight: bold; margin-bottom: 8px">未保存数据</p>
            <el-table
              :data="tempPrizeList"
              border
              size="mini"
              style="width: 100%"
            >
              <el-table-column label="ID" prop="id" width="70" align="center" />
              <el-table-column label="商品图片" align="center" width="100">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="width: 50px; height: 50px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="180" />
              <el-table-column label="等级" width="120" align="center">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.level_id"
                    placeholder="等级"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in levelOptions"
                      :key="item.level_id"
                      :label="item.name"
                      :value="item.level_id"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="赏品类型" width="110" align="center">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                    }"
                  >
                    {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="浮动类型"
                width="130"
                align="center"
                :key="7"
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.type" style="width: 100%">
                    <el-option label="不动" :value="0"></el-option>
                    <el-option label="上升" :value="1"></el-option>
                    <el-option label="掉落" :value="2"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="价格" width="110" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.price"
                    placeholder="价格"
                    style="width: 100%"
                  />
                </template>
              </el-table-column>
              <el-table-column label="回收价" width="110" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.recovery_price"
                    placeholder="回收价"
                    style="width: 100%"
                  />
                </template>
              </el-table-column>
              <el-table-column label="概率" width="100" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.probability"
                    placeholder="概率"
                    style="width: 100%"
                  />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="color: #f56c6c"
                    @click="delTempPrize(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <p style="font-weight: bold; margin-bottom: 8px">已保存数据</p>
            <div
              v-loading="prizeLoading"
              style="max-height: 300px; overflow-y: auto"
            >
              <el-table
                :data="prizeList"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  label="商品ID"
                  prop="goods_id"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="ID"
                  prop="id"
                  width="70"
                  align="center"
                />
                <el-table-column
                  label="层级"
                  prop="box"
                  width="70"
                  align="center"
                />
                <el-table-column
                  label="等级名称"
                  prop="level_name"
                  width="100"
                  align="center"
                />
                <el-table-column label="赏品类型" width="120" align="center">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品"
                        : "未知"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="浮动类型" width="120" align="center">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.type == 0
                        ? "不动"
                        : scope.row.type == 1
                        ? "上升"
                        : scope.row.type == 2
                        ? "掉落"
                        : "未知"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" align="center" width="120">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="180"
                />
                <el-table-column
                  label="单价"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="兑换价格"
                  prop="recovery_price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="概率"
                  prop="probability"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                  align="center"
                />
                <el-table-column
                  label="操作"
                  width="180"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click.stop="openEditPrize(scope.row)"
                    >
                      编辑
                    </el-button>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #f56c6c"
                      @click.stop="delPrize(scope.row.id)"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handlePrizeSizeChange"
                @current-change="handlePrizeCurrentChange"
                :current-page="prizeParams.page"
                :page-sizes="[10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="prizeTotal"
                style="margin-top: 15px; text-align: right"
              />
            </div>
          </div>
        </el-dialog>

        <!-- PC 选择赏品弹窗 -->
        <el-dialog
          title="选择赏品"
          :visible.sync="addPrizeDialogVisible"
          width="1000px"
          append-to-body
        >
          <div
            style="
              display: flex;
              gap: 10px;
              margin-bottom: 15px;
              align-items: center;
            "
          >
            <el-select
              v-model="addPrizeParams.type"
              placeholder="选择等级分类"
              style="width: 180px"
              @change="handleGoodsTypeChange"
              clearable
            >
              <el-option
                v-for="item in goodsLevelGroup"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
            <el-select
              v-model="addPrizeParams.level_id"
              placeholder="选择具体等级"
              style="width: 180px"
              clearable
            >
              <el-option
                v-for="item in currGoodsLevelList"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              />
            </el-select>
            <el-input
              v-model="addPrizeParams.title"
              placeholder="商品名称"
              style="width: 220px"
              clearable
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getAddPrizeList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetAddPrizeSearch">
              重置
            </el-button>
          </div>
          <div
            v-loading="addPrizeLoading"
            style="max-height: 400px; overflow-y: auto"
          >
            <el-table
              ref="addPrizeTableRef"
              :data="addPrizeList"
              border
              stripe
              size="mini"
              @row-click="handleSelectAddPrizeRow"
            >
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column label="ID" prop="id" width="70" align="center" />
              <el-table-column label="商品图片" align="center" width="100">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="width: 50px; height: 50px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="220" />
              <el-table-column
                label="价格"
                prop="price"
                width="100"
                align="center"
              />
              <el-table-column
                label="类型"
                prop="type_name"
                width="100"
                align="center"
              />
              <el-table-column label="赏品类型" width="110" align="center">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                    }"
                  >
                    {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="等级"
                prop="level_name"
                width="120"
                align="center"
              />
            </el-table>
            <el-pagination
              @size-change="handleAddPrizeSizeChange"
              @current-change="handleAddPrizeCurrentChange"
              :current-page="addPrizeParams.page"
              :page-sizes="[10, 20, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="addPrizeTotal"
              style="margin-top: 15px; text-align: right"
            />
          </div>
          <div slot="footer">
            <el-button @click="addPrizeDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmAddPrize"
              >确认添加</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 编辑赏品弹窗 -->
        <el-dialog
          title="编辑赏品"
          :visible.sync="editPrizeDialog"
          width="600px"
          append-to-body
        >
          <el-form
            :model="editPrizeForm"
            label-width="110px"
            style="margin-top: 15px"
          >
            <el-form-item label="赏品ID">
              <span style="color: #666; font-weight: bold">{{
                editPrizeForm.prize_id
              }}</span>
            </el-form-item>
            <el-form-item label="商品信息">
              <div style="display: flex; align-items: center; gap: 12px">
                <img
                  :src="editPrizeForm.goods_image"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 6px;
                    border: 1px solid #eee;
                  "
                />
                <span style="font-size: 14px">{{
                  editPrizeForm.goods_title
                }}</span>
              </div>
            </el-form-item>
            <el-form-item label="等级">
              <el-select
                v-model.number="editPrizeForm.level_id"
                placeholder="请选择等级"
                style="width: 280px"
              >
                <el-option
                  v-for="item in levelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="赏品类型">
              <el-select
                v-model.number="editPrizeForm.goods_type"
                style="width: 280px"
              >
                <el-option label="真实赏品" :value="1"></el-option>
                <el-option label="虚拟赏品" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="浮动类型">
              <el-select
                v-model.number="editPrizeForm.type"
                style="width: 280px"
              >
                <el-option label="不动" :value="0"></el-option>
                <el-option label="上升" :value="1"></el-option>
                <el-option label="掉落" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="概率">
              <el-input
                v-model.number="editPrizeForm.probability"
                placeholder="请输入概率"
                style="width: 280px"
              />
            </el-form-item>
            <el-form-item label="单价">
              <el-input
                v-model.number="editPrizeForm.price"
                placeholder="请输入单价"
                style="width: 280px"
              />
            </el-form-item>
            <el-form-item label="兑换价格">
              <el-input
                v-model.number="editPrizeForm.recovery_price"
                placeholder="请输入兑换价格"
                style="width: 280px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="editPrizeDialog = false">取消</el-button>
            <el-button type="primary" @click="submitEditPrize"
              >确认保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="爬塔名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | 层级:{{ item.tower_num }} | 售价¥{{
                    item.price
                  }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>销量：{{ item.sales }}</div>
              <div>收入：{{ item.income }}</div>
              <div>支出：{{ item.pay }}</div>
              <div>
                利润：
                <span v-if="Number(item.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color: item.income - item.pay >= 0 ? '#00c48c' : '#f56c6c',
                  }"
                >
                  {{
                    (((item.income - item.pay) / item.income) * 100).toFixed(2)
                  }}%
                </span>
              </div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(item)"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- ====================== 移动端详情弹窗 ====================== -->
        <el-dialog
          title="爬塔详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="爬塔ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileDetailRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="层级数">{{
                mobileDetailRow.tower_num
              }}</el-descriptions-item>
              <el-descriptions-item label="销量">{{
                mobileDetailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="收入">{{
                mobileDetailRow.income
              }}</el-descriptions-item>
              <el-descriptions-item label="支出">{{
                mobileDetailRow.pay
              }}</el-descriptions-item>
              <el-descriptions-item label="利润">
                <span v-if="Number(mobileDetailRow.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      mobileDetailRow.income - mobileDetailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((mobileDetailRow.income - mobileDetailRow.pay) /
                        mobileDetailRow.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="排序">{{
                mobileDetailRow.sort
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileDetailRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileDetailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                mobileDetailRow.created_at
              }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{
                mobileDetailRow.updated_at
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- ====================== 移动端编辑弹窗 ====================== -->
        <el-dialog
          title="编辑爬塔"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="爬塔名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="爬塔图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="openMobileImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileEditForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileEditForm.image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileEditForm.price"
                placeholder="价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="层级数" prop="tower_num">
              <el-input
                v-model="mobileEditForm.tower_num"
                placeholder="层级数"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="mobileEditForm.sort"
                placeholder="排序"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- ====================== 移动端独立图片选择弹窗 ====================== -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="imageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="getImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="resetImageSearch">重置</el-button>
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="selectMobileImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    selectedMobileImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    selectedMobileImageUrl == img.url
                      ? '#f0f7ff'
                      : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>
            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="imageSearch.page"
                :page-size="imageSearch.page_size"
                layout="prev, pager, next"
                :total="imageTotal"
                pager-count="2"
                small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="confirmMobileSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "ClimbTower",
  data() {
    return {
      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        box_id: "",
        name: "",
        image: "",
        price: "",
        tower_num: "",
        sort: "",
      },
      mobileImageDialogVisible: false,
      selectedMobileImageUrl: "",

      // PC 独立图片弹窗
      pcImageDialogVisible: false,
      selectedPcImageUrl: "",

      prizeDialogVisible: false,
      prizeLoading: false,
      prizeList: [],
      prizeTotal: 0,
      prizeParams: { page: 1, page_size: 10, box_id: "", box: "" },
      boxNumDetailVisible: false,
      boxNumDetail: null,
      fightBoxNumId: "",
      loading: false,
      tableData: [],
      pageTotal: 0,
      searchParams: { page: 1, page_size: 10, name: "" },
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "名称", prop: "name" },
        { label: "图片", prop: "image" },
        { label: "价格", prop: "price" },
        { label: "销量", prop: "sales" },
        { label: "层级数", prop: "tower_num" },
        { label: "收入", prop: "income" },
        { label: "支出", prop: "pay" },
        { label: "利润", prop: "profit" },
        { label: "排序", prop: "sort" },
        { label: "状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "image",
        "price",
        "sales",
        "tower_num",
        "income",
        "pay",
        "profit",
        "sort",
        "status",
        "created_at",
        "updated_at",
        "action",
      ],
      dialogVisible: false,
      dialogType: "add",
      form: { name: "", image: "", sort: "", tower_num: "", price: "" },
      addRules: {
        name: [{ required: true, message: "请输入爬塔名称", trigger: "blur" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        tower_num: [
          { required: true, message: "请输入层级数", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      image_type: [],
      imageSearch: { page: 1, page_size: 12, type: "" },
      detailDialogVisible: false,
      detailRow: null,
      detailLoading: false,
      showFightBoxCard: false,
      numLoading: false,
      numList: [],
      numTotal: 0,
      numSearch: { page: 1, page_size: 10, box_id: "" },
      typeList: [],
      levelList: [],
      fightBoxNumDialog: false,
      fightBoxNumForm: {
        box: "",
        cycle_num: "",
        type: "",
        goods_id: "",
        price: "",
        probability_info: [],
        is_top: 0,
        image: "",
      },
      selectedGoodsName: "",
      goodsDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsParams: {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 8,
      },
      selectedGoodsId: null,
      addPrizeDialogVisible: false,
      addPrizeLoading: false,
      addPrizeList: [],
      addPrizeTotal: 0,
      addPrizeParams: {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 8,
      },
      goodsLevelGroup: [],
      currGoodsLevelList: [],
      tempPrizeList: [],
      levelOptions: [],
      currentBoxInfo: {},
      editPrizeDialog: false,
      editPrizeForm: {
        prize_id: "",
        origin_num: "",
        probability: "",
        goods_id: "",
        level_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
        goods_image: "",
        goods_title: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ====================== 移动端 ======================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },
    openMobileEdit(row) {
      this.mobileEditForm = {
        box_id: row.id,
        name: row.name,
        image: row.image || "",
        price: row.price + "",
        tower_num: row.tower_num + "",
        sort: row.sort + "",
      };
      this.mobileEditVisible = true;
    },
    async submitMobileEdit() {
      if (!this.mobileEditForm.name || !this.mobileEditForm.price) {
        this.$message.warning("请完善必填项");
        return;
      }
      this.loading = true;
      try {
        const res = await api.climbTower.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    // 移动端图片选择
    openMobileImageDialog() {
      this.mobileImageDialogVisible = true;
      this.selectedMobileImageUrl = "";
      this.getImageList();
    },
    selectMobileImage(img) {
      this.selectedMobileImageUrl = img.url;
    },
    confirmMobileSelectImage() {
      if (!this.selectedMobileImageUrl) return this.$message.warning("请选图");
      this.mobileEditForm.image = this.selectedMobileImageUrl;
      this.mobileImageDialogVisible = false;
    },

    // PC 图片选择
    openPcImageDialog() {
      this.pcImageDialogVisible = true;
      this.selectedPcImageUrl = "";
      this.getImageList();
    },
    selectPcImage(img) {
      this.selectedPcImageUrl = img.url;
    },
    confirmPcSelectImage() {
      if (!this.selectedPcImageUrl) return this.$message.warning("请选图");
      if (this.fightBoxNumDialog) {
        this.fightBoxNumForm.image = this.selectedPcImageUrl;
      } else {
        this.form.image = this.selectedPcImageUrl;
      }
      this.pcImageDialogVisible = false;
    },

    // ====================== 公共方法 ======================
    getList() {
      this.loading = true;
      api.climbTower.index({ params: this.searchParams }).then((res) => {
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.pageTotal = res.data.data.total;
        }
        this.loading = false;
      });
    },
    getImageList() {
      this.imageLoading = true;
      api.images.index({ params: this.imageSearch }).then((res) => {
        if (res.data.code == 1000) {
          this.imageList = res.data.data.data || [];
          this.imageTotal = res.data.data.total;
          this.image_type = res.data.data.image_type || [];
        }
        this.imageLoading = false;
      });
    },
    getImageTypeName(type) {
      const t = this.image_type.find((i) => i.type == type);
      return t ? t.desc : "未知";
    },
    resetImageSearch() {
      this.imageSearch = { page: 1, page_size: 12, type: "" };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.imageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.imageSearch.page = val;
      this.getImageList();
    },

    // 其余原有方法保持不变
    openEditPrize(row) {
      this.editPrizeForm = {
        prize_id: row.id,
        goods_id: row.goods_id,
        level_id: row.level_id,
        goods_type: row.goods_type,
        type: row.type,
        probability: row.probability,
        price: row.price,
        recovery_price: row.recovery_price,
        goods_image: row.goods_image,
        goods_title: row.goods_title,
      };
      this.editPrizeDialog = true;
    },
    async submitEditPrize() {
      let params = {
        prize_id: this.editPrizeForm.prize_id,
        goods_id: this.editPrizeForm.goods_id,
        level_id: this.editPrizeForm.level_id,
        goods_type: this.editPrizeForm.goods_type,
        type: this.editPrizeForm.type,
        probability: this.editPrizeForm.probability,
        price: this.editPrizeForm.price,
        recovery_price: this.editPrizeForm.recovery_price,
      };
      try {
        const res = await api.climbTower.editClimbTowerPrize(params);
        if (res.data.code == 1000) {
          this.editPrizeDialog = false;
          this.getPrizeList();
        }
      } catch (e) {}
    },
    async delPrize(prize_id) {
      this.$confirm("确定删除该赏品？", "提示", { type: "warning" })
        .then(async () => {
          try {
            const res = await api.climbTower.delClimbTowerPrize({ prize_id });
            if (res.data.code == 1000) this.getPrizeList();
          } catch (e) {}
        })
        .catch(() => this.$message.info("已取消"));
    },
    openAddPrizeDialog() {
      this.addPrizeParams = {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 8,
      };
      this.currGoodsLevelList = [];
      this.addPrizeDialogVisible = true;
      this.getAddPrizeList().then(() => {
        this.$nextTick(() => {
          if (!this.$refs.addPrizeTableRef) return;
          this.$refs.addPrizeTableRef.clearSelection();
          const tempIds = this.tempPrizeList.map((item) => item.id);
          this.addPrizeList.forEach((row) => {
            if (tempIds.includes(row.id))
              this.$refs.addPrizeTableRef.toggleRowSelection(row, true);
          });
        });
      });
    },
    async getAddPrizeList() {
      this.addPrizeLoading = true;
      try {
        const res = await api.goods.index({ params: this.addPrizeParams });
        if (res.data.code == 1000) {
          this.addPrizeList = res.data.data.data || [];
          this.addPrizeTotal = res.data.data.total || 0;
          this.goodsLevelGroup = res.data.data.goods_level || [];
          this.currGoodsLevelList = [];
        }
      } catch (e) {
      } finally {
        this.addPrizeLoading = false;
      }
    },
    handleGoodsTypeChange(val) {
      this.addPrizeParams.level_id = "";
      let group = this.goodsLevelGroup.find((item) => item.type == val);
      this.currGoodsLevelList = group ? group.goods_level : [];
    },
    handleSelectAddPrizeRow(row) {
      this.$refs.addPrizeTableRef.toggleRowSelection(row);
    },
    confirmAddPrize() {
      let selected = this.$refs.addPrizeTableRef.selection;
      if (!selected.length) return this.$message.warning("请选择商品");

      // 只对真实赏品做去重
      const existRealIds = new Map();
      this.tempPrizeList.forEach((item) => {
        if (item.goods_type == 1) {
          existRealIds.set(item.id, true);
        }
      });

      // 过滤：真实赏品已存在则跳过，虚拟赏品不过滤
      let newItems = selected.filter((item) => {
        return !existRealIds.has(item.id);
      });

      let arr = newItems.map((item) => ({
        id: item.id,
        image: item.image,
        title: item.title,
        level_id: item.level_id || "",
        goods_type: item.goods_type,
        type: 0,
        price: 0,
        recovery_price: 0,
        probability: 0,
      }));

      this.tempPrizeList = [...this.tempPrizeList, ...arr];
      this.addPrizeDialogVisible = false;
      this.$refs.addPrizeTableRef.clearSelection();
      this.$message.success(`已添加 ${newItems.length} 个赏品`);
      console.log(this.tempPrizeList);
    },
    delTempPrize(index) {
      this.tempPrizeList.splice(index, 1);
    },
    handleAddPrizeSizeChange(val) {
      this.addPrizeParams.page_size = val;
      this.getAddPrizeList();
    },
    handleAddPrizeCurrentChange(val) {
      this.addPrizeParams.page = val;
      this.getAddPrizeList();
    },
    resetAddPrizeSearch() {
      this.addPrizeParams = {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 8,
      };
      this.currGoodsLevelList = [];
      this.getAddPrizeList();
    },
    async openPrizeList(row) {
      if (this.prizeParams.box != row.box) this.tempPrizeList = [];
      this.prizeParams.box_id = row.box_id;
      this.prizeParams.box = row.box;
      this.currentBoxInfo = { ...row };
      this.prizeParams.page = 1;
      this.prizeDialogVisible = true;
      await this.getPrizeList();
    },
    async submitAddPrize() {
      if (!this.tempPrizeList.length)
        return this.$message.warning("请先选择赏品");
      let totalProb = 0;
      this.tempPrizeList.forEach(
        (item) => (totalProb += Number(item.probability || 0))
      );
      if (totalProb > 100) return this.$message.error("概率总和不能超过 100%");
      let prize_info = this.tempPrizeList.map((item) => ({
        goods_id: item.id,
        level_id: item.level_id,
        goods_type: item.goods_type || 1,
        type: item.type || 0,
        price: item.price || 0,
        recovery_price: item.recovery_price || 0,
        probability: item.probability || 0,
      }));
      let params = {
        box_id: this.currentBoxInfo.box_id,
        box: this.currentBoxInfo.box,
        prize_info: JSON.stringify(prize_info),
      };
      try {
        const res = await api.climbTower.addClimbTowerPrizet(params);
        if (res.data.code == 1000) {
          this.tempPrizeList = [];
          this.getPrizeList();
        }
      } catch (e) {}
    },
    async getPrizeList() {
      this.prizeLoading = true;
      try {
        const res = await api.climbTower.climbTowerPrizeList({
          params: this.prizeParams,
        });
        if (res.data.code == 1000) {
          this.prizeList = res.data.data.data || [];
          this.prizeTotal = res.data.data.total || 0;
          let levelData = res.data.data.level || [];
          this.levelOptions = levelData.map((item) => ({
            level_id: item.level_id,
            name: item.name,
          }));
        }
      } catch (e) {
      } finally {
        this.prizeLoading = false;
      }
    },
    handlePrizeSizeChange(val) {
      this.prizeParams.page_size = val;
      this.getPrizeList();
    },
    handlePrizeCurrentChange(val) {
      this.prizeParams.page = val;
      this.getPrizeList();
    },
    async handleStatusChange(row) {
      try {
        this.loading = true;
        await api.climbTower.status({ box_id: row.id, status: row.status });
        this.getList();
      } catch (e) {
        row.status = row.status == 1 ? 0 : 1;
      } finally {
        this.loading = false;
      }
    },
    handleRowClick(row) {
      this.detailRow = row;
      this.detailDialogVisible = true;
    },
    handleAdd() {
      this.dialogType = "add";
      this.resetForm();
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogType = "edit";
      this.form = {
        name: row.name,
        image: row.image || "",
        sort: row.sort + "",
        tower_num: row.tower_num + "",
        price: row.price + "",
        box_id: row.id,
      };
      this.dialogVisible = true;
    },
    showBoxNumDetail(row) {
      this.boxNumDetail = row;
      this.boxNumDetailVisible = true;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let params = {
          name: this.form.name,
          sort: this.form.sort,
          tower_num: this.form.tower_num,
          price: this.form.price,
          image: this.form.image,
        };
        if (this.dialogType == "edit") {
          params.box_id = this.form.box_id;
          api.climbTower.edit(params).then((res) => {
            if (res.data.code == 1000) {
              this.dialogVisible = false;
              this.getList();
            }
            this.loading = false;
          });
        } else {
          api.climbTower.add(params).then((res) => {
            if (res.data.code == 1000) {
              this.dialogVisible = false;
              this.getList();
            }
            this.loading = false;
          });
        }
      });
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "" };
      this.getList();
    },
    resetForm() {
      this.form = { name: "", image: "", sort: "", tower_num: "", price: "" };
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    async delClimbTowerNum(box_num_id) {
      this.$confirm("此操作将永久删除该层级, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await api.climbTower.delClimbTowerNum({ box_num_id });
            this.getClimbTowerNumList();
          } catch (e) {}
        })
        .catch(() => this.$message.info("已取消删除"));
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },
    async openFightBoxNum(row) {
      this.numSearch.box_id = row.id;
      this.numSearch.page = 1;
      this.showFightBoxCard = true;
      this.numLoading = true;
      const res = await api.climbTower.getClimbTowerNumList({
        params: this.numSearch,
      });
      if (res.data.code == 1000) {
        this.numList = res.data.data.data || [];
        this.numTotal = res.data.data.total || 0;
        this.typeList = res.data.data.type || [];
        this.levelList = res.data.data.level || [];
      }
      this.numLoading = false;
    },
    closeFightBoxCard() {
      this.showFightBoxCard = false;
    },
    handleNumSizeChange(val) {
      this.numSearch.page_size = val;
      this.getClimbTowerNumList();
    },
    handleNumCurrentChange(val) {
      this.numSearch.page = val;
      this.getClimbTowerNumList();
    },
    async getClimbTowerNumList() {
      this.numLoading = true;
      const res = await api.climbTower.getClimbTowerNumList({
        params: this.numSearch,
      });
      if (res.data.code == 1000) {
        this.numList = res.data.data.data || [];
        this.numTotal = res.data.data.total || 0;
      }
      this.numLoading = false;
    },
    handleFightBoxAdd() {
      this.fightBoxNumId = "";
      this.resetFightBoxNumForm();
      if (this.levelList.length > 0) {
        let arr = [];
        for (let i = 0; i < this.levelList.length; i++) {
          arr.push({ level_id: this.levelList[i].level_id, probability: 0 });
        }
        this.fightBoxNumForm.probability_info = arr;
      }
      this.fightBoxNumDialog = true;
    },
    resetFightBoxNumForm() {
      this.fightBoxNumForm = {
        box: "",
        cycle_num: "",
        type: "",
        goods_id: "",
        price: "",
        probability_info: [],
        is_top: 0,
        image: "",
      };
      this.selectedGoodsName = "";
      this.selectedGoodsId = null;
    },
    async handleFightBoxEdit(row) {
      this.fightBoxNumId = row.id;
      this.resetFightBoxNumForm();
      this.fightBoxNumForm.box = row.box;
      this.fightBoxNumForm.cycle_num = row.cycle_num;
      this.fightBoxNumForm.type = row.type;
      this.fightBoxNumForm.goods_id = row.goods_id;
      this.fightBoxNumForm.price = row.price;
      this.fightBoxNumForm.is_top = row.is_top;
      this.fightBoxNumForm.image = row.image;
      this.selectedGoodsId = row.goods_id;
      this.selectedGoodsName = row.goods_name || "";
      let probabilityArr = row.probability || [];
      let finalProb = [];
      this.levelList.forEach((level) => {
        let find = probabilityArr.find(
          (item) => item.level_id == level.level_id
        );
        finalProb.push({
          level_id: level.level_id,
          probability: find ? parseFloat(find.probability) : 0,
        });
      });
      this.fightBoxNumForm.probability_info = finalProb;
      this.fightBoxNumDialog = true;
    },
    async submitAdd() {
      if (!this.fightBoxNumForm.box) return this.$message.warning("请输入层级");
      if (!this.fightBoxNumForm.image)
        return this.$message.warning("请上传层级图片");
      let total = 0;
      this.fightBoxNumForm.probability_info.forEach(
        (item) => (total += Number(item.probability || 0))
      );
      if (total > 100) return this.$message.error("概率总和不能超过 100%");
      this.numLoading = true;
      try {
        const boxId = this.numSearch.box_id;
        if (this.fightBoxNumId) {
          const params = {
            box_num_id: this.fightBoxNumId,
            probability_info: JSON.stringify(
              this.fightBoxNumForm.probability_info
            ),
            price: this.fightBoxNumForm.price,
            is_top: this.fightBoxNumForm.is_top,
            image: this.fightBoxNumForm.image,
          };
          await api.climbTower.editClimbTowerNum(params);
        } else {
          const params = {
            box_id: boxId,
            box_num_info: JSON.stringify([
              {
                box: this.fightBoxNumForm.box,
                image: this.fightBoxNumForm.image,
                price: this.fightBoxNumForm.price,
                is_top: this.fightBoxNumForm.is_top,
                probability_info: this.fightBoxNumForm.probability_info,
              },
            ]),
          };
          await api.climbTower.addClimbTowerNum(params);
        }
        this.fightBoxNumDialog = false;
        this.getClimbTowerNumList();
      } catch (e) {
      } finally {
        this.numLoading = false;
      }
    },
    openGoodsDialog() {
      this.goodsDialogVisible = true;
      this.selectedGoodsId = null;
      this.getGoodsList();
    },
    async getGoodsList() {
      this.goodsLoading = true;
      try {
        const res = await api.goods.index({ params: this.goodsParams });
        if (res.data.code == 1000) {
          this.goodsList = res.data.data.data || [];
          this.goodsTotal = res.data.data.total || 0;
        }
      } catch (e) {
        this.$message.error("商品加载失败");
      } finally {
        this.goodsLoading = false;
      }
    },
    handleGoodsSizeChange(val) {
      this.goodsParams.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsParams.page = val;
      this.getGoodsList();
    },
    selectGoodsItem(item) {
      this.selectedGoodsId = item.id;
    },
    confirmSelectGoods() {
      if (!this.selectedGoodsId) return this.$message.warning("请选择商品");
      const sel = this.goodsList.find(
        (item) => item.id == this.selectedGoodsId
      );
      if (sel) {
        this.fightBoxNumForm.goods_id = sel.id;
        this.selectedGoodsName = sel.title;
      }
      this.goodsDialogVisible = false;
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.goods-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.goods-item {
  width: 120px;
  text-align: center;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}
.goods-selected {
  border-color: #409eff;
  background: #f0f7ff;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/climbTower/index.vue